export default class FormsModule {

    constructor() {
        const forms = document.querySelectorAll('form');
        if(forms.length != 0) forms.forEach(this.initForm.bind(this))
    }

    initForm(form) {
       const selectElements = form.querySelectorAll('.formulate__field--select');
       selectElements.forEach(this.createDropdown);
       if (selectElements.length > 0){
            document.addEventListener('click', this.closeAllDropdowns);
       }
    }

    closeAllDropdowns(){
        let formSelect = document.getElementsByClassName("formulate__field--select active");
        for (let i = 0; i < formSelect.length; i++){
            let elm = formSelect[i];
            let selectItems = elm.getElementsByClassName('field__select__select-items')[0];
            let selectSelected = elm.getElementsByClassName('field__select__select-selected')[0];
            elm.classList.remove('active');
            selectSelected.classList.remove('field__select__select-arrow-active');
            selectItems.classList.add('field__select__select-hide');
        };
    }

    createDropdown(formSelectDiv){
        let formSelect = formSelectDiv;
        let selectElement = formSelectDiv.querySelector('select');
        let temp = formSelectDiv.getElementsByClassName("field__select__critical");
        if(temp.length > 0){
            temp[0].outerHTML = "";
        }


        let a = document.createElement("DIV");
        a.setAttribute("class", "field__select__select-selected");
        a.innerHTML = selectElement.options[selectElement.selectedIndex].innerHTML;
        formSelectDiv.appendChild(a);

        let b = document.createElement("DIV");
        b.setAttribute("class", "field__select__select-items field__select__select-hide");

        let h = selectElement.nextElementSibling;

        for(let i = 1; i < selectElement.length; i++){
            let c = document.createElement("DIV");
            c.innerHTML = '<div class="field__select__selected-check"></div>' + selectElement.options[i].innerHTML;

            let selectItemClick = (e) => {
                for(let j = 0; j < selectElement.length; j++){
                    if(selectElement.options[j].innerHTML == e.currentTarget.innerText){
                        selectElement.selectedIndex = j;
                        h.innerHTML = e.currentTarget.innerText;
                        let y = formSelect.getElementsByClassName("field__select__same-as-selected");
                        for(let k = 0; k < y.length; k++){
                            y[k].removeAttribute("class");
                        }
                        e.currentTarget.setAttribute("class", "field__select__same-as-selected");
                        break;
                    }
                }
                a.click();
            }
            c.addEventListener('click', selectItemClick);


            b.appendChild(c);
        }

        let selectHeaderClicked = (e) => {
            e.stopPropagation();
            b.classList.toggle('field__select__select-hide');
            e.currentTarget.classList.toggle('field__select__select-arrow-active');
            formSelect.classList.toggle('active');
        }
        a.addEventListener("click", selectHeaderClicked);

        let headerSelectHeight = formSelect.clientHeight;
        b.style.top = headerSelectHeight + 1 + "px";

        formSelectDiv.appendChild(b);
    }
}
